import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IconsModule } from 'core/components/icons/icons.module';
import { iconPromo } from 'main/icons/icon-promo';
import { iconCopy } from 'main/icons/icon-copy';
import { iconCheckRound } from 'main/icons/icon-check-round';
import { iconClose } from 'main/icons/icon-close';
import { MediaIfDirective } from 'core/directives/media-if.directive';
import { TranslateModule } from '@ngx-translate/core';
import { PromocodeData } from 'src/app/pages/external-pages/feedback/feedback/models/promocode.model';

@Component({
  selector: 'app-promo-line',
  templateUrl: './promo-line.component.html',
  styleUrls: ['./promo-line.component.scss'],
  standalone: true,
  host: { ngSkipHydration: 'true' },
  imports: [IconsModule, MediaIfDirective, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PromoLineComponent {
  readonly promoIcon = iconPromo;
  readonly copyIcon = iconCopy;
  readonly checkIcon = iconCheckRound;
  readonly closeIcon = iconClose;

  @Input() promo?: PromocodeData | null;
  @Input() showCopyCheck = false;

  @Output() openPricing = new EventEmitter<void>();
  @Output() copyCode = new EventEmitter<void>();
  @Output() closePromo = new EventEmitter<void>();
}
